// ═══════════════════════════════════════════════
//  ASQUARETRAVELGOA — GOA-FIRST TRAVEL DATA
// ═══════════════════════════════════════════════

export const destinations = [];

export const packages = [];

export const testimonials = [];

export const stats = [
  { value: 10000, label: 'Happy Travelers', suffix: '+', icon: '😊' },
  { value: 1000, label: 'Goa Trips Planned', suffix: '+', icon: '🌴' },
  { value: 5, label: 'Years in Goa', suffix: '', icon: '🏆' },
  { value: 98, label: 'Satisfaction %', suffix: '%', icon: '⭐' },
];

// ── GOA EXPERIENCES (for homepage section) ──────────────────
export const goaExperiences = [
  { icon: '🏄', title: 'Water Sports', desc: 'Parasailing, jet-ski, banana boat & more at Baga and Calangute' },
  { icon: '🚢', title: 'Sunset Cruise', desc: 'Cruise the Mandovi river with live Goan music and cocktails' },
  { icon: '🌶️', title: 'Spice Plantation', desc: 'Walk through aromatic spice farms with a traditional Goan lunch' },
  { icon: '🏛️', title: 'Heritage Walk', desc: 'Explore 500-year-old Portuguese churches and Fontainhas quarter' },
  { icon: '🐬', title: 'Dolphin Spotting', desc: 'Early morning boat ride to spot Goa\'s playful wild dolphins' },
  { icon: '🎵', title: 'Goan Nightlife', desc: 'Beach shacks, live music, and nights that stretch into dawn' },
];
